<template lang="pug">
  CoverSection.PageCover(:backgroundImg="item.backgroundImg")
    .CoverSection_background(ref="background")
      .CoverSection_background_asset
          AdaptativeImg(:derivatives="item.derivatives" :type="'cover'" :fit="true" :name="item.get('attributes.title')")
    .CoverSection_background_cache(ref="backgroundcache")

    PageTitle(:title="item.get('attributes.title')")

</template>

<script>

import PageTitle from '@/components/common/PageTitle'
import AdaptativeImg from '@/components/common/AdaptativeImg'
import CoverSection from '@/components/common/CoverSection'

export default {
  props: ['item'],
  components: { PageTitle, CoverSection, AdaptativeImg },
  mounted () {
    this.$parallax.set(this.$refs.backgroundcache, { opacity: 0 }, { opacity: 0 }, { opacity: 1 }, null, -0.3)
    this.catchElement()
  },
  beforeDestroy () {
    this.detachElement()

    this.$parallax.remove(this.$refs.backgroundcache)
    this.$refs.backgroundcache.removeEventListener('mousemove', this.captureMousePosition)
  },
  methods: {
    captureMousePosition (event) {
      this.rect = this.$refs.background.getBoundingClientRect()
      this.x = Math.floor((event.clientX - (this.rect.left + (this.rect.width / 2))) / 70)
      this.y = Math.floor((event.clientY - (this.rect.top + (this.rect.height / 2))) / 70)

      TweenMax.to(this.$refs.background, 2, { x: this.x, y: this.y, ease: Quint.easeOut })
    },
    catchElement () {
      if (!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) return

      this.$refs.backgroundcache.addEventListener('mousemove', this.captureMousePosition)
    },
    detachElement () {
      this.$refs.backgroundcache.removeEventListener('mousemove', this.captureMousePosition)

      TweenMax.to(this.$refs.background, 1, { x: 0, y: 0, ease: Quint.easeOut })
    }
  }
}

</script>

<style lang="stylus" scoped>

.CoverSection_

  &_background

    opacity 0.25

</style>
